// store/modules/user.js
export default {
  namespaced: true,  // 必须开启命名空间
  state: {
    finish: false,
  },
  mutations: {
  setFinish(state, data) {
    state.finish = data;
  }
  },
  actions: {
  },
  getters: {
   
  }
}




// WEBPACK FOOTER //
// ./src/store/modules/user/user.js